<template>
  <div class="contents_wrapper">
    <Header :title="'施設予約'" />
    <div v-if="room" class="contents">
      <div class="booking_main">
        <div class="booking_text">以下の条件で予約しますか？</div>
        <div class="booking_info">
          <ul class="booking_detail">
            <li class="booking_detail_item">
              <div class="bookig_item_icon">
                <img :src="$designResource.iconClock" alt />
              </div>
              <div
                v-if="startTime"
                class="bookig_item_text bokking-time"
              >{{formatedTime(startTime)}} ～ {{formatedTime(searchdTime)}}</div>
              <div v-else class="bookig_item_text bokking-time">～ {{formatedTime(searchdTime)}}</div>
            </li>
            <li class="booking_detail_item">
              <div class="bookig_item_icon">
                <img :src="$designResource.iconDoor" alt />
              </div>
              <div class="bookig_item_text">{{room.name}}</div>
            </li>
          </ul>
        </div>
      </div>
      <ButtonGroup @next="book()" :loading="loading">
        <div class="booking_btn_icon">
          <img :src="$designResource.bookingCheck2" alt />
        </div>
        <div class="booking_btn_text">予約する</div>
      </ButtonGroup>
    </div>
    <AlertMessage @hideMessage="$router.push(resultPath)" />
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import AlertMessage from "../components/AlertMessage.vue";
import ButtonGroup from "../components/ButtonGroup.vue";

import roomService from "../services/roomService";
import checkinService from "../services/checkinService";
import meetingService from "../services/meetingService";
import loggerService from "../services/loggerService";

import moment from "moment";

export default {
  components: {
    Header,
    AlertMessage,
    ButtonGroup
  },
  data: function() {
    return {
      room: null,
      resultPath: { path: `/main` },
      startTime: null,
      searchdTime: null,
      loading: false
    };
  },
  created: function() {
    loggerService.pageView("Booking");
    var _this = this;
    var roomId = this.$route.params.roomId;
    if (!this.$route.query["bookon"]) {
      this.$router.push({
        path: `/main`
      });
    }
    if (this.$route.query["startTime"])
      this.startTime = new Date(Number(this.$route.query["startTime"]));
    this.searchdTime = new Date(Number(this.$route.query["bookon"]));
    roomService.getRooms().then(function(ret) {
      _this.room = ret.find(e => e.id == roomId);
    });
  },
  methods: {
    formatedTime(time) {
      return moment(time).format("HH:mm");
    },
    checkDate: function() {
      return moment(this.searchdTime) > moment(new Date()).add(10, "m");
    },
    requested: function() {},
    book: function() {
      var _this = this;
      if (_this.loading) {
        return;
      }
      if (!_this.checkDate()) {
        return;
      }
      _this.loading = true;
      if (this.$route.query["iclUid"]) {
        meetingService.expand(
          {
            subject: this.$route.query["subject"],
            endDate: this.startTime,
            icalId: this.$route.query["iclUid"]
          },
          _this.room.address,
          moment(this.searchdTime),
          evt => {
            checkinService.doCheckin(evt.icalId, _this.room.id, "", () => {
              let event;
              try {
                event = new CustomEvent("alertMessage", {
                  detail: "リクエストを送信しました"
                });
              } catch (e) {
                event = document.createEvent("CustomEvent");
                event.initCustomEvent(
                  "alertMessage",
                  false,
                  false,
                  "リクエストを送信しました"
                );
              }
              _this.resultPath = {
                path: `/room/${_this.room.id}`,
                query: { expanded: 1 }
              };
              window.dispatchEvent(event);
            });
          }
        );
      } else {
        meetingService.book(
          _this.room.address,
          this.startTime,
          moment(this.searchdTime),
          () => {
            let event;
            try {
              event = new CustomEvent("alertMessage", {
                detail: "リクエストを送信しました"
              });
            } catch (e) {
              event = document.createEvent("CustomEvent");
              event.initCustomEvent(
                "alertMessage",
                false,
                false,
                "リクエストを送信しました"
              );
            }
            if (this.$route.query["roomFrom"]) {
              _this.resultPath = {
                path: `/room/${this.$route.query["roomFrom"]}`,
                query: { expanded: 1 }
              };
            }
            window.dispatchEvent(event);
          }
        );
      }
    }
  }
};
</script>

<style lang="scss">
.booking_main {
  width: 100%;
  height: calc(100% - 160px);
  box-sizing: border-box;
}
.booking_text {
  color: $txtColor;
  font-size: 18px;
  width: 100%;
  text-align: center;
}
.booking_info {
  width: 85%;
  margin: 30px auto;
  background-color: #fff;
  border-radius: 5px;
  box-sizing: border-box;
  padding: 20px;
}
.booking_detail {
  width: 100%;
}
.booking_detail_item {
  display: flex;
  align-items: center;
  padding: 10px 0;
  box-sizing: border-box;
}
.bookig_item_icon {
  width: 35px;
}
.bookig_item_icon > img {
  width: 25px;
}
.bookig_item_text {
  font-size: 16px;
  width: calc(100% - 40px);
  line-height: 1.4;
}
.bokking-time {
  color: #666666;
}
.booking_btn_icon {
  width: 40px;
}
.booking_btn_icon > img {
  width: 26px;
}
.booking_btn_text {
  font-size: 18px;
}
</style>